/**
 * <EdInputPop v-model="value"></EdInputPop>
 * @description input 放大输入
 */

import EdInputPop from './src/EdInputPop.vue';

/* istanbul ignore next */
EdInputPop.install = function (Vue) {
  Vue.component(EdInputPop.name, EdInputPop)
}

export default EdInputPop;
